<template>
  <div class="rhlistDrawer">
    <Drawer
      class="common-drawer"
      :title="title"
      v-model="showInDrawer"
      :mask-closable="false"
      :width="dologwidth"
      @on-close="drwcloseDrawer"
      :scrollable="true"
    >
      <Form
        ref="formValidate"
        :rules="ruleValidate"
        :model="formData"
        label-position="top"
      >
        <Row :gutter="16">
          <Col span="24">
            <div class="grouping">指标信息</div>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="指标名称" prop="name">
              <Input v-model="formData.name" placeholder="请输入" />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="属性名称" prop="functionName">
              <span slot="label"
                >属性名称
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="支持中文、大小写字母、日文、数字、短划线、下划线、斜杠和小数点，必须以中文、英文或数字开头，不超过 30 个字符"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Input
                :disabled="!!formData.id"
                v-model="formData.functionName"
                maxlength="30"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="单位" prop="unit">
              <Select
                @on-select="utilNameMthods"
                @on-open-change="updateChangeUtil"
                ref="unittrue"
                :clearable="unittrue"
                v-model="formData.unit"
                placeholder="请选择"
              >
                <!-- @on-change="utilNameMthods" -->
                <Option
                  :value="data.unit"
                  v-for="(data, key) in utilList"
                  :key="key"
                  >{{ data.unitName }}</Option
                >
              </Select>
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="属性编码" prop="identifier">
              <span slot="label"
                >属性编码
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="支持小写字母、数字和下划线、必须以小写字母开头 不超过 50 个字符"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Input
                :disabled="!!formData.id"
                v-model="formData.identifier"
                :maxlength="50"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <Col span="24">
            <FormItem label="存储类型" prop="dataType">
              <Select
                ref="dataTypetrue"
                :clearable="dataTypetrue"
                v-model="formData.dataType"
                placeholder="请选择"
              >
                <Option
                  :value="data"
                  v-for="(data, key) in dataTypeoption"
                  :key="key"
                  >{{ data }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <Row :gutter="16">
              <Col span="5">
                <FormItem label="取值范围">
                  <Input
                    style="width: 90px"
                    placeholder="最小值"
                    v-model="formData.dataMin"
                    type="number"
                  ></Input>
                </FormItem>
              </Col>
              <Col
                class="u-flex"
                span="1"
                style="position: relative; left: -1px"
                >-</Col
              >
              <Col span="11">
                <FormItem label="">
                  <Input
                    type="number"
                    placeholder="最大值"
                    style="margin-top: 26px; width: 90px"
                    v-model="formData.dataMax"
                  ></Input>
                </FormItem>
              </Col>
            </Row>
          </Col>
          <Col span="24">
            <FormItem label="指标组" prop="line">
              <Select
                ref="linetrue"
                :clearable="linetrue"
                v-model="formData.line"
                placeholder="请选择"
              >
                <Option
                  :value="data.value"
                  v-for="(data, key) in groupOption"
                  :key="key"
                  >{{ data.lable }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <div class="kkeyname">
            <Col span="24">
              <FormItem label="图标" prop="keyname">
                <Poptip
                  style="width: 100%"
                  v-model="iconvisible"
                  :confirm="false"
                  placement="bottom"
                  trigger="click"
                >
                  <SelectInput
                    ref="SelectInput"
                    :iconvisible="iconvisible"
                    :formData="formData"
                  />
                  <!-- <Input
                  style="width: 100%"
                  v-model="formData.keyname"
                  placeholder="请输入"
                ></Input> -->
                  <div slot="content" class="poptip">
                    <div
                      @click="iconChange(indx)"
                      class="pot"
                      v-for="(indx, key) in imageOption"
                      :key="key"
                    >
                      <div class="u-flex">
                        <img :src="indx.iconNormalFullPath" />
                        <img :src="indx.iconAbnormalFullPath" />
                        <img :src="indx.iconAlarmFullPath" />
                      </div>
                    </div>
                  </div>
                </Poptip>
              </FormItem>
            </Col>
          </div>
          <Col span="24">
            <div class="lineColor">
              <FormItem label="曲线颜色" prop="lineColor">
                <Select
                  ref="color"
                  on-change="colorMethos"
                  v-model="formData.lineColor"
                  placeholder="请选择"
                  :clearable="colortrue"
                >
                  <div
                    slot="prefix"
                    v-if="formData.lineColor"
                    style="width: 20px; height: 20px"
                    :style="{ background: formData.lineColor }"
                  ></div>
                  <Option
                    :value="data"
                    v-for="(data, key) in copycloseoptiuon"
                    :key="key"
                    :label="data"
                  >
                    <div class="u-flex">
                      <div
                        style="width: 20px; height: 20px; margin-right: 10px"
                        :style="{ background: data }"
                      ></div>
                      <div>{{ data }}</div>
                    </div>
                  </Option>
                </Select>
              </FormItem>
            </div>
          </Col>

          <Col span="24">
            <div class="grouping">报警和算法</div>
          </Col>
          <Col span="24">
            <FormItem label="阈值" prop="secureLine">
              <Select
                ref="secureLinetrue"
                :clearable="secureLinetrue"
                v-model="formData.secureLine"
                placeholder="请选择"
              >
                <Option
                  :value="data.lable"
                  v-for="(data, key) in thresholdLineoption"
                  :key="key"
                  >{{ data.lable }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col
            span="24"
            v-if="formData.secureLine && formData.secureLine !== '无'"
          >
            <FormItem label="动态阈值" :key="11265" prop="thresholdLine">
              <RadioGroup
                @on-change="randioMethos0"
                v-model="formData.thresholdLine"
              >
                <Radio :label="1">
                  <span>是</span>
                </Radio>
                <Radio :label="0">
                  <span>否</span>
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="波动计算" prop="isFluctuate">
              <RadioGroup
                @on-change="randioMethos1"
                v-model="formData.isFluctuate"
              >
                <Radio :label="1">
                  <span>是</span>
                </Radio>
                <Radio :label="0">
                  <span>否</span>
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="单调性计算" prop="isMonotonicity">
              <RadioGroup
                @on-change="randioMethos2"
                v-model="formData.isMonotonicity"
              >
                <Radio :label="1">
                  <span>是</span>
                </Radio>
                <Radio :label="0">
                  <span>否</span>
                </Radio>
              </RadioGroup>
            </FormItem>
          </Col>
          <Col span="24">
            <div class="grouping">点位信息</div>
          </Col>
          <Col span="24">
            <FormItem label="网关寄存器类型" prop="registerType">
              <span slot="label"
                >网关寄存器类型
              </span>
              <Select
                ref="registerTypetrue"
                :clearable="registerTypetrue"
                v-model="formData.registerType"
                placeholder="请选择"
                @on-change="handleChangeRegisterType"
              >
                <Option
                  :key="type.label"
                  :value="type.value"
                  v-for="type in registerTypeList"
                >
                  {{ type.value }} - {{ type.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="偏移量" prop="offset">
              <span slot="label"
                >偏移量
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="范围是0～65535"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Input type="number" v-model="formData.offset" maxlength="5" placeholder="请输入0~65535之间的任意数字" @input="handleOffsetInput" />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="网关寄存器地址" prop="address">
              <span slot="label"
                >网关寄存器地址
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="网关寄存器地址，由寄存器类型和偏移量组成"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Input disabled v-model="formData.address" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="字节序" prop="byteOrder">
              <span slot="label"
                >字节序
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="1表示ABCD，2表示BADC，3表示CDAB，4表示DCBA"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Select
                ref="byteOrdertrue"
                :clearable="byteOrdertrue"
                v-model="formData.byteOrder"
                placeholder="请选择"
              >
                <Option
                  :key="type.label"
                  :value="type.value"
                  v-for="type in byteOrderList"
                >
                  {{ type.value }} - {{ type.label }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <!-- <Col span="24">
            <FormItem label="寄存器地址" prop="registerAddress">
              <span slot="label"
                >寄存器地址
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="16进制格式，如0x01"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Input v-model="formData.registerAddress" placeholder="请输入" />
            </FormItem>
          </Col> -->
          <Col span="24">
            <FormItem label="数据类型" prop="pointType">
              <Select
                ref="pointTypetrue"
                :clearable="pointTypetrue"
                v-model="formData.pointType"
                placeholder="请选择"
              >
                <Option
                  :key="ind"
                  :value="device2"
                  v-for="(device2, ind) in ctypeoption"
                >
                  {{ device2 }}</Option
                >
              </Select>
            </FormItem>
          </Col>
          <!-- <Col span="24">
            <FormItem label="读功能码" prop="readFunctionCode">
              <Select
                ref="readFunctionCodetrue"
                :clearable="readFunctionCodetrue"
                v-model="formData.readFunctionCode"
                placeholder="请选择"
              >
                <Option
                  :value="data"
                  v-for="(data, key) in readFunctionCodes"
                  :key="key"
                  >{{ data }}
                </Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="写功能码">
              <Select
                ref="writeFunctionCodetrue"
                :clearable="writeFunctionCodetrue"
                v-model="formData.writeFunctionCode"
                placeholder="请选择"
              >
                <Option
                  :value="data"
                  v-for="(data, key) in writeFunctionCodes"
                  :key="key"
                  >{{ data }}
                </Option>
              </Select>
            </FormItem>
          </Col> -->
          <Col span="24">
            <FormItem label="小数位数">
              <Slider v-model="formData.dataLen" placeholder="请输入" :min="0" :max="255" :step="1" :disabled="!['FLOAT', 'DOUBLE', 'float', 'double'].includes(formData.pointType)" show-input />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="缩放因子">
              <Input v-model="formData.scaling" type="number" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="24">
            <FormItem label="数据转换参数b">
              <Input v-model="formData.convertB" type="number" placeholder="请输入" />
            </FormItem>
          </Col>
          <Col span="24">
            <div class="grouping">质量位信息</div>
            <Col span="24">
              <FormItem label="质量位" prop="isQuality">
                <RadioGroup
                  @on-change="randioMethos"
                  v-model="formData.isQuality"
                >
                  <Radio :label="1">
                    <span>是</span>
                  </Radio>
                  <Radio :label="0">
                    <span>否</span>
                  </Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Col>
          <Col v-if="formData.isQuality == 1" span="24">
            <FormItem
              required
              label="质量位寄存器地址"
              key="999"
              prop="qualityRegisterAddress"
            >
              <span slot="label"
                >质量位寄存器地址
                <span>
                  <Tooltip
                    trigger="hover"
                    theme="light"
                    :max-width="350"
                    :transfer="true"
                    content="16进制格式，如0x01"
                  >
                    <img
                      src="@/assets/images/wh.png"
                      style="
                        width: 12px;
                        height: 12px;
                        position: relative;
                        top: 1px;
                        left: 1px;
                      "
                      alt=""
                    />
                  </Tooltip>
                </span>
              </span>
              <Input
                @input="qualityRegisterAddressmethos"
                v-model="formData.qualityRegisterAddress"
                placeholder="请输入"
              />
            </FormItem>
          </Col>
          <Col span="24" v-if="formData.isQuality == 1">
            <FormItem label="质量位详情" prop="qualitys">
              <div @click="addqualitys" class="pointemitfont">编辑</div>
              <template v-if="formData.qualitys">
                <template v-if="!$c.isEmptyObject(formData.qualitys)">
                  {{ setQuaTyMethods(formData.qualitys) }}
                </template>
              </template>
            </FormItem>
          </Col>
        </Row>
      </Form>
      <div class="drawer-footer">
        <Button
          class="anchorPoint-oilSite-edit-button"
          type="primary"
          id="btn-list-sucess"
          @click="submitForm('formValidate')"
          :loading="btnLoading"
          >提交</Button
        >
        <Button style="margin-left: 8px" @click="drwcloseDrawer">取消</Button>
      </div>
    </Drawer>
    <prointMdoel
      @change="changeMethods"
      :formData="formData"
      v-model="modelShow"
    />
  </div>
</template>

<script>
import ls from "store2";
import deepcopy from "deepcopy";
import { mapState } from "vuex";

import {
  identifierIcon,
  identifierIconAdd,
  identifierIconUpdate,
} from "@/api/business/pointList.js";
import SelectInput from "@/components/SelectInput/index";
import emitDeice from "./emit-deice.vue";
import Cupload from "@/components/Cupload/index.vue";
import prointMdoel from "./proint-model.vue";

export default {
  name: "poinrlist-drawer",
  components: { emitDeice, Cupload, prointMdoel, SelectInput },
  props: {
    showDrawer: Boolean,
    closeDrawer: Function,
    dataCenter: Object,
    getLists: Function,
    curItemDetail: Object,
    cityList: {},
    imageOption: Array,
    colorOption: Array,
    utilOption: Array,
    groupOption: Array,
    init: {},
    thresholdLineoption: Array,
  },
  data() {
    return {
      writeFunctionCodetrue: false,
      readFunctionCodetrue: false,
      pointTypetrue: false,
      secureLinetrue: false,
      colortrue: false,
      linetrue: false,
      dataTypetrue: false,
      unittrue: false,
      registerTypetrue: false,
      byteOrdertrue: false,
      copycloseoptiuon: [],
      thresholdApplyoption: ["高", "低"],
      dataTypeoption: ["INT", "DOUBLE", "FLOAT", "TEXT", "DATE"],

      typeoption: ["动态", "平稳", "混合"],
      ctypeoption: [
        "INT16",
        "INT32",
        "FLOAT",
        "BOOL",
        "DOUBLE",
        "UINT16",
        "UINT32",
        "INT64",
        "UINT64",
      ],
      registerTypeList: [
        {
          label: 'Coils',
          value: '0'
        },
        {
          label: 'Input Discrete',
          value: '1'
        },
        {
          label: 'Input Registers',
          value: '3'
        },
        {
          label: 'Holding Registers',
          value: '4'
        },
      ],
      byteOrderList: [
        {
          label: 'ABCD',
          value: '1'
        },
        {
          label: 'BADC',
          value: '2'
        },
        {
          label: 'CDAB',
          value: '3'
        },
        {
          label: 'DCBA',
          value: '4'
        },
      ],
      readFunctionCodes: ["无", "0x01", "0x02", "0x03", "0x04"],
      writeFunctionCodes: ["无", "0x05", "0x06", "0x0f", "0x10"],
      modelShow: false,
      list: [],
      userRole: ls.get("userRole"),
      title: "",
      showInDrawer: false,
      btnLoading: false,
      formData: {
        keyname: "",
        lineColor: "",
        oilSiteTypeId: null,
        oilSiteIotName: null,
        tenantId: null,
        deviceId: null,
        oilProductId: null,
        qualitys: [],
        address: '',
        dataMin: undefined,
        dataMax: undefined,
      },
      iconvisible: false,
      ruleValidate: {
        isMonotonicity: [
          {
            required: true,
            message: "请选择单调性计算",
            trigger: "change",
          },
        ],
        isFluctuate: [
          {
            required: true,
            message: "请选择波动计算",
            trigger: "change,blur",
          },
        ],
        functionName: [
          {
            required: true,

            trigger: "change,blur",
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入指标名称（物联网）"));
              }
              const regex =
                /^[\u4e00-\u9fa5a-zA-Z0-9][\u4e00-\u9fa5a-zA-Z0-9-_\/.]*$/;
              let bo = regex.test(value);

              if (bo) {
                callback();
              } else {
                callback(new Error("请输入正确的指标名称（物联网）"));
              }

              // if (!value) {
              //   callback(new Error("请输入指标功能名称"));
              // } else if (/^[a-zA-Z0-9]/.test(value)) {
              //   callback();
              // } else if (/^[\u4e00-\u9fa5]/.test(value)) {
              //   callback();
              // } else {
              //   callback(new Error("请输入正确的指标名称"));
              // }
            },
          },
        ],
        orderNum: [
          {
            required: true,
            message: "请输入展示位置",
            trigger: "change",
          },
        ],
        identifier: [
          {
            required: true,
            // message: "请输入指标标识",
            trigger: "change",
            validator: (rule, value, callback) => {
              try {
                if (!value) {
                  callback(new Error("请输入指标标识"));
                  return;
                }
                let regex = /^[a-z][a-z0-9_]{0,49}$/;

                if (regex.test(value)) {
                  callback();
                } else {
                  callback(new Error("请输入正确的字符"));
                }
              } catch (error) {}
              // if (value === 0) {
              //   callback();
              // } else if (!value) {
              //   callback(new Error("请选择质量位"));
              // } else {
              //   callback();
              // }
            },
          },
        ],

        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "change,blur",
          },
        ],
        dataType: [
          {
            required: true,
            message: "请选择存储类型",
            trigger: "change",
          },
        ],
        dataMin: [
          {
            required: true,
            message: "请填写最小值",
            trigger: "change",
          },
        ],
        dataMax: [
          {
            required: true,
            message: "请填写最大值",
            trigger: "change",
          },
        ],
        isQuality: [
          {
            required: true,
            message: "请选择质量位",
            trigger: "change,blur",
            validator: (rule, value, callback) => {
              let vales = this.formData.isQuality;

              if (value === 0) {
                callback();
              } else if (!value) {
                callback(new Error("请选择质量位"));
              } else {
                callback();
              }
            },
          },
        ],
        isMonotonicity: [
          {
            required: true,

            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback();
              } else if (!value) {
                callback(new Error("请选择是否计算单调性"));
              } else {
                callback();
              }
            },
          },
        ],
        isFluctuate: [
          {
            required: true,

            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback();
              } else if (!value) {
                callback(new Error("请选择是否计算波动值"));
              } else {
                callback();
              }
            },
          },
        ],
        isShow: [
          {
            required: true,
            message: "请选择是否展示给客户",
            trigger: "change",
          },
        ],
        secureLine: [
          {
            required: true,
            message: "请选择阈值",
            trigger: "change",
          },
        ],
        thresholdLine: [
          {
            required: true,
            // message: "请输入注意值",
            trigger: "change",
            validator: (rule, value, callback) => {
              if (value === 0) {
                callback();
              } else if (!value) {
                callback(new Error("请选择动态阈值"));
              } else {
                callback();
              }
            },
          },
        ],
        remarks: [
          {
            required: true,
            message: "请选择是否差分",
            trigger: "change",
          },
        ],

        keyname: [
          // {
          //   required: true,
          //   message: "请选择图标",
          //   trigger: "change",
          // },
          {
            required: true,

            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value) {
                this.$refs["SelectInput"].error = true;
                callback(new Error("请选择图标"));
              } else {
                this.$refs["SelectInput"].error = false;
                callback();
              }
            },
          },
        ],
        line: [
          {
            required: true,
            message: "请输入指标组",
            trigger: "change",
          },
        ],
        pointType: [
          {
            required: true,
            message: "请输入数据类型",
            trigger: "change",
          },
        ],
        registerType: [
          {
            required: true,
            message: '请选择网关寄存器类型',
            trigger: 'blur',
            validator: (node, value, callback) => {
              if (['0', '1', '3', '4'].includes(value)) {
                callback();
              } else {
                callback(new Error('请选择网关寄存器类型'));
              }
            }
          }
        ],
        offset: [
          {
            required: true,
            message: '请输入偏移量',
            trigger: 'change,blur'
          },
          {
            message: '请正确输入偏移量',
            trigger: 'change,blur',
            validator: (node, value, callback) => {
              if (value < 0 || value > 65535) {
                callback(new Error('请正确输入偏移量'));
              } else {
                callback();
              }
            },
          },
        ],
        // readFunctionCode: [
        //   {
        //     required: true,
        //     message: "请输入读功能码",
        //     trigger: "change",
        //   },
        // ],
        scaling: [
          {
            required: true,
            message: "请输入缩放比例",
            trigger: "change",
          },
        ],

        // name: [

        //   {
        //     required: true,
        //     message: "请输入",
        //     t器顺序rigger: "change",
        //   },
        //   // {
        //   //   required: true,
        //   //   validator: validatePassCheck,
        //   //   trigger: "blur",
        //   // },
        // ],
        qualitys: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入质量位详情"));
              }
              if (this.$c.isEmptyObject(value)) {
                callback(new Error("请输入质量位详情"));
              } else {
                callback();
              }
            },
            trigger: "change,blur",
          },
        ],
        lineColor: [
          {
            required: true,
            message: "请选择颜色",
            trigger: "change",
          },
        ],

        qualityRegisterAddress: [
          {
            required: true,
            message: "请输入质量位寄存器地址",
            trigger: "change",
            // validator: (rule, value, callback) => {

            //   if(!value){
            //      callback(new Error("请输入质量位寄存器地址"))
            //   }else{
            //      callback();
            //   }

            // },
          },
        ],
        // registerAddress: [
        //   {
        //     required: true,
        //     message: "请填写寄存器地址",
        //     trigger: "change,blur",
        //   },
        // ],
        byteOrder: [
          {
            required: true,
            message: '请选择字节序',
            trigger: 'blur',
            validator: (node, value, callback) => {
              if (value) {
                callback();
              } else {
                callback(new Error('请选择字节序'));
              }
            },
          },
        ],
      },
      utilList: [],
      UtilLoading: true,
      customUntobj: {
        //自定义单位
        util: "",
        utilName: "",
      },
    };
  },
  computed: {
    ...mapState({
      dologwidth: (state) => state.dologwidth,
    }),
  },
  mounted() {},
  methods: {
    colorMethos(e) {},
    randioMethos0() {
      this.$refs.formValidate.validateField("thresholdLine");
    },
    randioMethos1() {
      this.$refs.formValidate.validateField("isFluctuate");
    },
    randioMethos2() {
      this.$refs.formValidate.validateField("isMonotonicity");
    },
    randioMethos() {
      this.$refs.formValidate.validateField("isQuality", (e) => {});
    },
    updatselectUtil(row) {},
    updateChangeUtil(row) {
      let dropMenus = this.$refs.unittrue.$el.querySelector(
        ".ivu-select-dropdown"
      );
      this.$nextTick(() => {
        if (dropMenus) {
          dropMenus.scrollTop = 0;
        }
      });
    },
    updateUtil(row) {
      this.customUntobj = {
        //自定义单位
        util: "",
        utilName: "",
      };
      let list = this.utilOption.map((e) => {
        const { unit, unitName } = e;
        return {
          unit,
          unitName,
        };
      });
      list.push({
        unit: "自定义",
        unitName: "自定义",
      });
      list.unshift({
        unit: "无",
        unitName: "无",
      });
      if (row.unit) {
        let item = list.find((e) => e.unit == row.unit);

        if (!item) {
          this.customUntobj = {
            util: row.unit,
            utilName: row.unitName,
          };

          // list.push({
          //   unit: row.unit,
          //   unitName: row.unitName,
          // });
        }
      }
      this.utilList = list;
    },
    utilNameMthods(e) {
      if (!e) return;

      if (e.label !== "自定义") {
        let findItem = this.utilList.find((e1) => e1.unit == e.value);
        this.formData.unitName = findItem.unitName;
      } else {
        this.addUtilName();
      }
    },
    addUtilName() {
      let UtilName = "";
      let Util = "";
      let customUntobj = this.customUntobj;
      if (customUntobj.util != "") {
        UtilName = this.customUntobj.utilName;
        Util = this.customUntobj.util;
      }
      this.$Modal.confirm({
        loading: this.UtilLoading,
        render: (h) => {
          return [
            h(
              "div",
              {
                class: "dev-mo-config",
                attrs: {
                  id: "dev-mo-config",
                },
              },
              [
                h(
                  "div",
                  {
                    class: "pro-model-title",
                  },
                  `自定义单位`
                ),
                [
                  h(
                    "div",
                    {
                      class: "u-flex",
                      style: {
                        position: "relative",
                        top: "6px",
                      },
                    },
                    [
                      h(
                        "div",
                        {
                          class: "flex",
                          style: {
                            width: "49%",
                            marginRight: "10px",
                          },
                        },
                        [
                          h("Input", {
                            attrs: {
                              id: "dev-select",
                            },
                            style: {
                              with: "100%",
                            },
                            props: {
                              value: UtilName,
                              placeholder: "请输入中文名称",
                            },
                            on: {
                              input: (event) => {
                                UtilName = event.toString();
                              },
                            },
                          }),
                        ]
                      ),
                      h(
                        "div",
                        {
                          class: "flex",
                          style: {
                            width: "49%",
                          },
                        },
                        [
                          h("Input", {
                            attrs: {
                              id: "dev-select",
                              placeholder: "请输入英文名称",
                            },

                            style: {
                              with: "100%",
                            },
                            props: {
                              value: Util,
                              placeholder: "请输入英文名称",
                            },
                            on: {
                              // "on-change": (event) => {

                              //   Util = event.target._value;
                              // },
                              input: (event) => {
                                Util = event.toString();
                              },
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ],
              ]
            ),
          ];
        },
        onOk: () => {
          this.$nextTick(() => {
            if (UtilName == "") {
              this.$Message.info("请输入单位中文名称");
              const footerElement = document.querySelector(
                ".ivu-modal-confirm-footer"
              );
              const loadingButtonElement =
                footerElement.querySelector(".ivu-btn-loading");

              const loadLoopElement =
                loadingButtonElement.querySelector(".ivu-load-loop");

              loadLoopElement.parentNode.removeChild(loadLoopElement);
              loadingButtonElement.classList.remove("ivu-btn-loading");
              return;
            }
            if (Util == "") {
              this.$Message.info("请输入单位英文名称");
              const footerElement = document.querySelector(
                ".ivu-modal-confirm-footer"
              );
              const loadingButtonElement =
                footerElement.querySelector(".ivu-btn-loading");

              const loadLoopElement =
                loadingButtonElement.querySelector(".ivu-load-loop");

              loadLoopElement.parentNode.removeChild(loadLoopElement);
              loadingButtonElement.classList.remove("ivu-btn-loading");
              return;
            }

            let rows = this.utilList.filter((item) => {
              if (item.unit == Util || item.unitName == UtilName) {
                return true;
              }
            });

            if (rows && rows.length > 0) {
              this.$Message.info("单位名称或者英文名称已经存在");
              const footerElement = document.querySelector(
                ".ivu-modal-confirm-footer"
              );
              const loadingButtonElement =
                footerElement.querySelector(".ivu-btn-loading");

              const loadLoopElement =
                loadingButtonElement.querySelector(".ivu-load-loop");

              loadLoopElement.parentNode.removeChild(loadLoopElement);
              loadingButtonElement.classList.remove("ivu-btn-loading");
              return;
            }
            // this.utilList.unshift({
            //   unit: Util,
            //   unitName: UtilName,
            // });
            this.customUntobj = {
              util: Util,
              utilName: UtilName,
            };

            //
            this.unittrue = true;
            let dropMenus = this.$refs.unittrue.$el.querySelector(
              ".ivu-select-dropdown"
            );
            this.$nextTick(() => {
              this.$refs.unittrue.clearSingleSelect();

              let t1 = setTimeout(() => {
                this.formData.unit = "自定义";
                this.formData.unitName = "自定义";
                // this.formData.unit = Util;
                // this.formData.unitName = UtilName;
                // this.UtilLoading = false;
                this.$Modal.remove();
                this.$forceUpdate();
                this.unittrue = false;

                clearTimeout(t1);
              }, 200);
            });
          });
        },
        onCancel: () => {
          this.unittrue = true;

          this.$nextTick(() => {
            this.$refs.unittrue.clearSingleSelect();

            let t1 = setTimeout(() => {
              if (this.customUntobj.util !== "") {
                this.formData.unit = "自定义";
                this.formData.unitName = "自定义";
              } else {
                this.formData.unit = "无";
                this.formData.unitName = "无";
              }

              // this.UtilLoading = false;
              this.$Modal.remove();
              this.unittrue = false;
              clearTimeout(t1);
            }, 200);
          });
        },
      });
    },
    setQuaTyMethods(obj) {
      return Object.values(obj).toString();
    },

    qualityRegisterAddressmethos(e) {
      //  this.$refs['formValidate'].
      this.$refs.formValidate.validateField("qualityRegisterAddress");
    },
    changeMethods(index) {
      this.formData.qualitys = index;
      this.$nextTick((e) => {
        this.$refs.formValidate.validateField("qualitys");
      });
    },
    addqualitys() {
      this.modelShow = true;
    },
    updateFrom(from) {
      let from1 = { ...from };
      const {
        secureLine,
        thresholdLine,
        unitName,
        unit,
        readFunctionCode,
        writeFunctionCode,
        writeFunctionCodetrue,
      } = from1;
      if (!readFunctionCode) {
        from1.readFunctionCode = "无";
      }

      if (!unit) {
        from1.unit = "无";
        from1.unitName = "无";
      } else {
        let item = this.utilList.find((e) => e.unit == unit);
        if (!item) {
          from1.unitName = "自定义";
          from1.unit = "自定义";
        }
      }

      if (from1.line) {
        from1.line = from1.line.toString();
      }
      if (from1.orderNum) {
        from1.orderNum = from1.orderNum.toString();
      }

      if (!from1.secureLine) {
        from1.secureLine = "无";
      } else {
        if (thresholdLine) {
          from1.thresholdLine = 1;
        } else {
          from1.thresholdLine = 0;
        }
      }

      if (from1.iconAbnormalFullPath) {
        let imageOption = this.imageOption;
        let item = imageOption.find((e) => {
          const {
            iconAbnormalFullPath,
            iconAbnormalKey,
            iconAlarmFullPath,
            iconAlarmKey,
            iconNormalFullPath,
            iconNormalKey,
          } = e;
          if (
            iconAbnormalKey == from1.iconAbnormalKey &&
            iconAlarmKey == from1.iconAlarmKey &&
            iconNormalKey == from1.iconNormalKey
          ) {
            return true;
          }
        });

        if (item) {
          from1.keyname = item.key;
        }
      }
      if (from1.isFluctuate) {
        from1.isFluctuate = Number(from1.isFluctuate);
      }
      if (from1.isShow) {
        from1.isShow = Number(from1.isShow);
      }

      if (from1.isQuality) {
        from1.isQuality = Number(from1.isQuality);
      }
      if (!writeFunctionCode) {
        from1.writeFunctionCode = "无";
      }

      return from1;
    },
    iconChange(row) {
      this.formData.keyname = row.key;
      this.formData.iconAlarmKey = row.iconAlarmKey;
      this.formData.iconNormalKey = row.iconNormalKey;
      this.formData.iconAbnormalKey = row.iconAbnormalKey;

      this.formData.iconAbnormalFullPath = row.iconAbnormalFullPath;
      this.formData.iconAlarmFullPath = row.iconAlarmFullPath;
      this.formData.iconNormalFullPath = row.iconNormalFullPath;

      this.iconvisible = false;
      this.$refs.formValidate.validateField("keyname");
    },
    cleartRest() {
      let t = setTimeout(() => {
        this.unittrue = true;
        this.dataTypetrue = true;
        this.linetrue = true;
        this.colortrue = true;
        this.secureLinetrue = true;
        this.pointTypetrue = true;
        this.registerTypetrue = true;
        this.byteOrdertrue = true;
        this.readFunctionCodetrue = true;
        this.writeFunctionCodetrue = true;
        this.$nextTick(async () => {
          this.$refs["unittrue"].clearSingleSelect();
          this.$refs["dataTypetrue"].clearSingleSelect();
          this.$refs["linetrue"].clearSingleSelect();
          this.$refs["color"].clearSingleSelect();
          this.$refs["secureLinetrue"].clearSingleSelect();
          this.$refs["pointTypetrue"].clearSingleSelect();
          this.$refs["registerTypetrue"].clearSingleSelect();
          this.$refs["byteOrdertrue"].clearSingleSelect();
          this.$refs["readFunctionCodetrue"].clearSingleSelect();
          this.$refs["writeFunctionCodetrue"].clearSingleSelect();
          let t1 = setTimeout(() => {
            this.unittrue = false;
            this.dataTypetrue = false;
            this.linetrue = false;
            this.colortrue = false;
            this.secureLinetrue = false;
            this.pointTypetrue = false;
            this.registerTypetrue = false;
            this.byteOrdertrue = false;
            this.readFunctionCodetrue = false;
            this.writeFunctionCodetrue = false;

            clearTimeout(t1);
          }, 100);
          clearTimeout(t);
        });
      }, 300);
    },

    drwcloseDrawer() {
      clearTimeout(this.tttimer);
      this.tttimer = null;
      this.closeDrawer();
      this.$nextTick(async () => {
        await this.$c.sleep(300);
        this.$refs.formValidate.resetFields();
        this.cleartRest();
      });
    },

    submitForm(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          try {
            let formDataCopy = deepcopy({...this.formData, offset: Number(this.formData.offset)});
            const {
              secureLine,
              thresholdLine,
              writeFunctionCode,
              readFunctionCode,
            } = formDataCopy;
            if (readFunctionCode == "无") {
              formDataCopy.readFunctionCode = null;
            }
            if (writeFunctionCode == "无") {
              formDataCopy.writeFunctionCode = null;
            }
            if (formDataCopy.unit == "无") {
              formDataCopy.unit = undefined;
              formDataCopy.unitName = undefined;
            }

            if (formDataCopy.unit == "自定义") {
              formDataCopy.unit = this.customUntobj.util;
              formDataCopy.unitName = this.customUntobj.utilName;
            }

            if (formDataCopy.thresholdLine == "无") {
              formDataCopy.thresholdLine = undefined;
            }
            if (secureLine == "无") {
              formDataCopy.secureLine = undefined;
              formDataCopy.thresholdLine = undefined;
            } else {
              if (thresholdLine == 1) {
                formDataCopy.thresholdLine = secureLine;
              } else {
                formDataCopy.thresholdLine = undefined;
              }
            }

            if (!['FLOAT', 'DOUBLE', 'float', 'double'].includes(formDataCopy.pointType)) {
              formDataCopy.dataLen = null;
            }

            this.btnLoading = true;
            try {
              let aoirest = !formDataCopy.id
                ? identifierIconAdd
                : identifierIconUpdate;

              if (formDataCopy.isQuality == 0) {
                formDataCopy.qualitys = {};
              }

              aoirest({ ...formDataCopy })
                .then((res) => {
                  if (res.code === "00000") {
                    this.init();
                    this.$Message.success("提交成功");
                    this.drwcloseDrawer(); // 关闭弹窗
                    this.getLists(); // 刷新列表
                  } else {
                    this.$Message.error(res.msg);
                  }
                  this.btnLoading = false;
                })
                .catch((error) => {
                  this.btnLoading = false;
                });
            } catch (error) {}
          } catch (error) {}
        } else {
        }
      });
    },
    // 格式化偏移量
    formatOffset: function (number) {
      const numberString = `${number}`;
      const needLength = 5 - numberString.length;
      let fillingString = '';

      for (let i = 0; i < needLength; i ++) {
        fillingString += '0';
      }

      return `${fillingString}${numberString}`;
    },
    // 网关类型改变
    handleChangeRegisterType: function (event) {
      console.log('register type', event);
      this.formData.address = `${this.formData.registerType}${this.formatOffset(this.formData.offset || '')}`;
    },
    // 偏移量
    handleOffsetInput: function () {
      this.formData.address = `${this.formData.registerType}${this.formatOffset(this.formData.offset)}`;
    }
  },
  watch: {
    curItemDetail: {
      handler: async function (newValue, oldValue) {
        this.$refs["SelectInput"].error = false;

        this.updateUtil(newValue);

        if (newValue.id) {
          this.title = "编辑点表";
          let row = this.updateFrom(newValue);
          this.formData = this.$c.deepClone(row);
          let colos = this.$c.deepClone(this.colorOption);

          if (row.lineColor) {
            colos.push(row.lineColor);
          }

          this.copycloseoptiuon = colos;
        } else {
          this.formData = {
            keyname: "",
            qualitys: [],
            isFluctuate: undefined,
            isShow: undefined,
            remarks: undefined,
            isQuality: undefined,
            isMonotonicity: undefined,
            unit: "无",
            unitName: "无",
            writeFunctionCode: "无",
          };

          this.title = "新增点表";
        }
      },
      deep: true,
    },
    showDrawer: {
      handler: function (newValue, oldValue) {
        this.showInDrawer = newValue;
        if (newValue) {
          this.$nextTick(() => {
            var modal = document.getElementsByClassName("ivu-form")[0];
            modal.scrollTop = 0;
          });
          if (!this.curItemDetail.id) {
            this.copycloseoptiuon = this.$c.deepClone(this.colorOption);
            console.log('this.copycloseoptiuon',this.copycloseoptiuon)
          }
        } else {
        }
      },
      deep: true,
    },
  },
};
</script>

<style lang='less' scoped>
.grouping {
  font-size: 16px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  color: #262626;
  border-bottom: 1px solid rgba(112, 112, 112, 0.1);
  padding-bottom: 5px;
  margin-bottom: 12px;
  padding-left: 5px;
  font-weight: 549;
}
.rhlistDrawer {
}
</style>
<style lang="less">
.rhWrapUpload {
  .imgWrap {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;

    .imgs {
      position: relative;
      width: 150px;
      height: 150px;
      text-align: center;
      // border: 1px solid #f2f2f2;
      overflow: hidden;

      img {
        height: 100%;
        width: 100%;
        object-fit: cover;
      }

      .ivu-icon {
        position: absolute;
        font-size: 24px;
        z-index: 2;
        top: 0px;
        right: 0px;
        cursor: pointer;
      }
    }

    .addImg {
      position: relative;
      width: 150px;
      height: 150px;
      text-align: center;
      border: 1px dashed #dcdee2;
      cursor: pointer;

      .ivu-icon {
        color: #dcdee2;
        font-size: 30px;
        margin-top: 30px;
      }

      .up_label {
        width: 150px;
        height: 150px;
        cursor: pointer;

        input {
          width: 1%;
          height: 1%;
          font-size: 0;
        }
      }
    }
  }

  .tip {
    padding: 10px 0;
    color: #aaa;
  }
}

.percentWrap {
  position: relative;

  .name {
    position: absolute;
    top: -12px;
    font-size: 12px;
    color: #666;

    .ivu-icon {
      font-size: 14px;
    }
  }

  .ivu-progress-success .ivu-progress-text {
    color: #19be6b;
    vertical-align: bottom;
  }

  .ivu-progress-wrong .ivu-progress-text {
    color: #ed4014;
    vertical-align: bottom;
  }
}

.up-files {
  position: absolute;
  left: 0;
  opacity: 0;
  width: 150px;
  height: 150px;
  font-size: 0;
  cursor: pointer;
}

.listpw {
  position: absolute;
  left: 96px;
  top: -4px;
}
.dev-title {
  font-size: 16px;
  color: #17233d;
  font-weight: 500;
  position: relative;
  top: -6px;
}
.dev-normal {
  white-space: nowrap;
  margin-right: 10px;
}
.poptip {
  width: 507px;
  height: 300px;
  overflow: auto;
  padding: 10px;
  img {
    width: 30px;
    height: 30px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
}

.remmove {
  cursor: pointer;
  opacity: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: 2px;
  img {
    width: 30px;
    object-fit: cover;
  }
}
.kkeyname {
  width: 100% !important;
  .ivu-poptip-rel {
    width: 100% !important;
  }
}
.ivu-poptip-popper {
  width: 100% !important;
  .ivu-poptip-body-content {
    overflow-x: hidden !important;
  }
}
</style>